<template>
  <div class="buttons is-justify-content-center pt-2">
    <button
      v-if="isOpponentOnline && isPvP"
      class="button is-danger is-outlined"
      @click="handleRematch"
    >
      REMATCH
    </button>
    <button class="button is-primary is-outlined" @click="goToHome">
      GO HOME
    </button>
    <button class="button is-primary is-outlined" @click="goToLobby">
      GO TO LOBBY
    </button>
    <button
      v-if="isPvP"
      class="button is-info is-outlined"
      @click="newGame(5 * 60)"
    >
      NEW 5-MINUTE MATCH
    </button>
    <button
      v-if="isPvP"
      class="button is-info is-outlined"
      @click="newGame(15 * 60)"
    >
      NEW 15-MINUTE MATCH
    </button>
  </div>
</template>

<script>
import { EventBus } from "@/services/event-bus";
import { mapGetters } from "vuex";
import { ONLINE_STATUS } from "../../constants";

export default {
  name: "InGameNav",

  props: ["match"],

  computed: {
    ...mapGetters(["getUserId", "getOnlinePlayers"]),

    isPvP() {
      if (!this.match.player1.aiLevel && !this.match.player2.aiLevel) {
        return true;
      }

      return false;
    },

    opponentPlayer() {
      if (!this.match) return null;
      if (!this.match.player1) return null;
      if (this.match.player1.user_id === this.getUserId) {
        return this.match.player2;
      }
      if (!this.match.player2) return null;
      if (this.match.player2.user_id === this.getUserId) {
        return this.match.player1;
      }
      return null;
    },

    isOpponentOnline() {
      if (!this.opponentPlayer) return false;
      if (!this.getOnlinePlayers || !this.getOnlinePlayers.length) return false;
      return !!this.getOnlinePlayers.find(
        (player) =>
          player.user_id === this.opponentPlayer.user_id &&
          player.status === ONLINE_STATUS.ACTIVE
      );
    },
  },

  methods: {
    handleRematch() {
      EventBus.$emit(
        "onRematch",
        this.opponentPlayer,
        this.match.duration,
        this.match.variant
      );
    },

    goToHome() {
      this.$router.push({ path: "/" });
    },

    goToLobby() {
      this.$router.push({ path: "/lobby" });
    },

    newGame(duration) {
      this.$router.push({
        path: `/lobby?duration=${duration}`,
      });
    },
  },
};
</script>

<style></style>
